module.exports = __webpack_public_path__ + "img/312C34_A2AAB3_61656A_808494-256px.3e7fc8e7.png";